class Delete {
  constructor(api) {
    this.api = api;
  }

  byEndpoint(endpoint, data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/" + endpoint + "/delete", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  validationByEndpoint(endpoint, data, onSuccess, onError) {
    return this.api.http_fibercloud
      .post("v1/" + endpoint + "/delete/validation", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
}

export default Delete;



// WEBPACK FOOTER //
// ./src/api/delete.js